import {Directive, ElementRef} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';

@Directive({
    selector: '[appScrollableTable]'
})
export class ScrollableTableDirective {

    constructor(el: ElementRef, private deviceService: DeviceDetectorService) {
        if (!(deviceService.isMobile() && deviceService.getDeviceInfo().browser == 'Safari')) {
            (el.nativeElement as HTMLTableElement).classList.add('table-responsive-md');
        }
    }


}
